@if (rowcount !== undefined) {
    <p>
        <em>{{
            (configTable
                ? "cs.bia.admin.editRelation.entriesFound"
                : "cs.bia.common.table.row.count"
            ) | hisUi: rowcount
        }}</em>
    </p>
}
@if (simplifiedTable !== undefined) {
    <p>
        <input
            type="checkbox"
            name="simplifiedTable"
            id="simplifiedTable"
            [checked]="simplifiedTable"
            value="simplifiedTable"
            (change)="onToggleSimplifiedTable()" />
        <label for="simplifiedTable">{{ "cs.bia.admin.editRelation.simplifyTable" | hisUi }}</label>
        <button
            hisImage="information"
            type="button"
            class="plamButton icon"
            [title]="'attr.helptext.txt' | hisUi"
            (click)="simplifiedTableHelptext = !simplifiedTableHelptext"></button>
        @if (simplifiedTableHelptext) {
            <span>
                <div class="plamHelptext">
                    {{ "cs.bia.admin.editRelation.simplifyTableHelptext" | hisUi }}
                </div>
            </span>
        }
    </p>
}
@if (selectableColumns && selectableColumns.length > 0) {
    <his-table-config
        [columns]="selectableColumns"
        [configuratedColumns]="configuredColumns"
        [enableReorderableColumns]="reorderable"
        (saved)="onSaved($event)"
        [enableFrozenColumns]="canFreezeColumns">
    </his-table-config>
}
@if (!filterActive) {
    <button
        [hisImage]="'FILTER'"
        class="plamButton icon"
        [title]="'de.his.faces.tags.table.tableFilter.enable' | hisUi"
        (click)="onFilterChanged(true)">
        {{ "de.his.faces.tags.table.tableFilter.enable" | hisUi }}
    </button>
}
@if (filterActive) {
    <button
        [hisImage]="'FILTER_RESET'"
        class="plamButton icon"
        [title]="'de.his.faces.tags.table.tableFilter.disable' | hisUi"
        (click)="onFilterChanged(false)">
        {{ "de.his.faces.tags.table.tableFilter.disable" | hisUi }}
    </button>
}
<button
    [hisImage]="'PANEL_CLOSE'"
    class="plamButton icon"
    [title]="'genericSearch.resultTable.tableFilter.resetFilter' | hisUi"
    (click)="onResetFilter()">
    {{ "genericSearch.resultTable.tableFilter.resetFilter" | hisUi }}
</button>
@if (treeTable) {
    <button
        id="TreeExpander"
        (click)="onExpandTree()"
        hisImage="TREE_INCREASE"
        class="icon">
        {{ "view.components.tree.expand_all" | hisUi }}
    </button>
    <button
        id="TreeCollapser"
        (click)="onCollapseTree()"
        hisImage="TREE_DECREASE"
        class="icon">
        {{ "view.components.tree.collapse_all" | hisUi }}
    </button>
}
